<template>
  <div>
    <el-row :gutter="20">

      <el-col :md="8" :lg="4">
          <el-select size="small" v-model="params.source_from" clearable placeholder="来源" @change="typesearch">
              <el-option v-for="item in source_from" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
          </el-select>
      </el-col>

      <el-col :span="5">
        <el-select size="small" v-model="params.spread_type" clearable placeholder="推广类型" @change="typesearch">
            <el-option v-for="item in spread_type" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
        </el-select>
      </el-col>

      <el-col :md="10" :lg="8">
          <el-date-picker v-model="upload_at" type="daterange" start-placeholder="生成时间" ange-separator="至" end-placeholder="生成时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="updateDateChange" size="mini"></el-date-picker>
      </el-col>
    </el-row>

   <el-table :data="data" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="spread_user_id" label="推广人id" width="100"></el-table-column>
      <el-table-column prop="userinfo.username" label="推广人" width="200"></el-table-column>
      <el-table-column prop="qrcodes" label="二维码" width="200">
        <template slot-scope="scope">
          <img :src="scope.row.qrcodes" style="width:60px;height:60px;" :alt="scope.row.spread_user">
        </template>
      </el-table-column>
      <el-table-column prop="source_from" label="请求来源" width="200">
          <template slot-scope="scope">
              <el-tag size="mini" effect="plain"  v-if="scope.row.source_from=='android'">android</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='ios'">ios</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='wxapp'">多店铺小程序</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='youxuanwxapp'">优选小程序</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='aliapp'">支付宝小程序</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='h5'">H5</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.source_from=='pc'">Pc</el-tag>
              <el-tag size="mini" effect="plain"  v-else >其他</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="spread_type" label="推广类型" width="200">
          <template slot-scope="scope">
              <el-tag size="mini" effect="plain"  v-if="scope.row.spread_type=='distributor'">店铺</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.spread_type=='distri_good'">店铺商品</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.spread_type=='custom'">自定义</el-tag>
              <el-tag size="mini" effect="plain"  v-else-if="scope.row.spread_type=='goods'">商品</el-tag>
              <el-tag size="mini" effect="plain"  v-else >其他</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="content" label="推广内容" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.content.length>=16 && showAll == 'none'">{{scope.row.content.slice(0,16)}}...<a @click="block_span(scope.row)">展开</a></span>
          <span v-else-if="scope.row.content.length>=16 && showAll === scope.row.id">{{scope.row.content}}<a @click="hide_span(scope.row)">收起</a></span>
          <span v-else-if="scope.row.content.length<16">{{scope.row.content}}</span>
          <span v-else>{{scope.row.content.slice(0,16)}}...<a @click="block_span(scope.row)">展开</a></span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="时间" width="250">
          <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>

      <el-table-column prop="counts" label="分享次数" width="200"></el-table-column>

    </el-table>
    <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page.sync="params.page"
                :total="total_count" :page-size="params.pageSize">
        </el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getContentList} from '@/api/spread'
  export default {
    data () {
      return {
        data: [],
        loading: false,
        showAll:'none',
        upload_at:'',
        source_from:[
              { value: 'Android', name: "Android" },
              { value: 'IOS', name: 'IOS' },
              { value: 'WXapp', name: '多店铺小程序' },
              { value: 'H5', name: "h5" },
              { value: 'Aliapp', name: "支付宝小程序" },
            {value:'youxuanWxapp',name:'优选小程序'},
              { value: 'PC', name: "Pc" },
          ],
        spread_type:[
              { name: '店铺', value: 'distributor' },
              { name: '商品', value: 'goods' },
              { name: '定制', value: 'custom' },
                { name: '店铺商品', value: 'distri_good' },
          ],
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      block_span(val){
        this.showAll = val.id
        console.log(this.showAll)
      },
      hide_span(){
        this.showAll = 'none'
      },
      getDataList () {
        this.loading = true
        getContentList(this.params).then(response => {

          this.data = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      },
      typesearch (){
          this.getDataList()
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      updateDateChange (val) {
          if (val && val.length > 0) {
              this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_upload_at = ''
              this.params.end_upload_at = ''
          }
          this.getDataList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      },

    },
    mounted () {
      console.log(this.showAll)
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// content.vue?3a5017ac